// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDN7l-UvoHE-rh9hVLm_Q3vQml8ZEWh24s",
  authDomain: "words-a7a3c.firebaseapp.com",
  projectId: "words-a7a3c",
  storageBucket: "words-a7a3c.appspot.com",
  messagingSenderId: "805089637076",
  appId: "1:805089637076:web:b75d6f6008c7ea44714141",
  measurementId: "G-YTV552W359"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db =  getFirestore(app);
export const auth = getAuth();